export const APP_ID = 'fso-ui-dashify-suite-app';
export const FEATURE_FLAGS_STORE_KEY = 'dashify-feature-flags-store';
